import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className = ''
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.55,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-147">
      {children}
    </motion.div>;
}